import React from "react";

export default function renderComponent(renderer: Renderer, props: React.Props<any> | GenericObject) {
    const Component = renderer.component;
    const mergedProps = {
        ...{},
        ...props
    };
    return <Component {...mergedProps} />;
}
